import React, { useState, useRef } from 'react';
import { Helmet } from "react-helmet";
import { useHistory } from 'react-router-dom';
import useSettingsContext from 'contexts/useSettingsContext';
import SettingsContext from 'contexts/SettingsContext';
import useCompetitionEntryState from 'contexts/useCompetitionEntryContext';
import timer from 'utils/timer';

import ValidationErrorCollection from 'validators/ValidationErrorCollection';

import CodeEntry from './CodeEntry';
import PrizeBlock from 'components/Prize/PrizeBlock';
import PrizeBlockDouble from 'components/Prize/PrizeBlockDouble';
import Step from 'components/Step/Step';
import Carousel from 'components/Carousel/Carousel'; 
import Link from 'components/Link/Link';
import Button from 'components/Button/Button';
import Video from '../Home/Video'
import SummaryTsandCs from 'components/SummaryTsandCs/SummaryTsandCs';

import Stage from 'components/Confetti/Stage';

import HomeHero from './HomeHero';

import How1 from 'assets/images/campaign/how-1.png';
import How1_2x from 'assets/images/campaign/how-1@2x.png';
import How2 from 'assets/images/campaign/how-2.png';
import How2_2x from 'assets/images/campaign/how-2@2x.png';
import How3 from 'assets/images/campaign/how-3.png';
import How3_2x from 'assets/images/campaign/how-3@2x.png';
import How3b from 'assets/images/campaign/how-3b.png';
import How3b_2x from 'assets/images/campaign/how-3b@2x.png';
import How4 from 'assets/images/campaign/how-4.png';
import How4_2x from 'assets/images/campaign/how-4@2x.png';
import How5 from 'assets/images/campaign/how-5.png';
import How5_2x from 'assets/images/campaign/how-5@2x.png';
import How6 from 'assets/images/campaign/how-6b.png';
import How6_2x from 'assets/images/campaign/how-6b@2x.png';


import players_mob from 'assets/images/campaign/players-mob.png';
import players_mob_2x from 'assets/images/campaign/players-mob@2x.png';
import players_tab from 'assets/images/campaign/players-tab.png';
import gcw_video from 'assets/videos/gcw1.mp4';
import gcw_video_mob from 'assets/videos/gcw1-mob.mp4';
import placeholder_image from 'assets/images/campaign/keyvis/gcw-placeholder.png';

//PRIZES

import VouchersMobRoi from 'assets/images/campaign/prizes/vouchers_Mob_roi.png';
import VouchersMobRoi2x from 'assets/images/campaign/prizes/vouchers_Mob_roi@2x.png';
import VouchersDeskRoi from 'assets/images/campaign/prizes/vouchers_desk_roi.png';
import VouchersDeskRoi2x from 'assets/images/campaign/prizes/vouchers_desk_roi@2x.png';

import VouchersMob from 'assets/images/campaign/prizes/vouchers_Mob.png';
import VouchersMob2x from 'assets/images/campaign/prizes/vouchers_Mob@2x.png';
import VouchersDesk from 'assets/images/campaign/prizes/vouchers_desk.png';
import VouchersDesk2x from 'assets/images/campaign/prizes/vouchers_desk@2x.png';

import MatchTicketsMob from 'assets/images/campaign/prizes/tickets_mob.png';
import MatchTicketsMob2x from 'assets/images/campaign/prizes/tickets_mob@2x.png';
import MatchTicketsDesk from 'assets/images/campaign/prizes/tickets_desk.png';
import MatchTicketsDesk2x from 'assets/images/campaign/prizes/tickets_desk@2x.png';




import analyticsService from 'services/analyticsService';
import CountrySelect from './CountrySelect';

import './Home.scss';
import useEffectOnce from 'hooks/useEffectOnce';

import PlayerBadge from 'components/PlayerBadge/PlayerBadge';
import prizeList from 'utils/prizes';
import CountryCtaModal from './CountryCtaModal';

export default () => {
  const [settings, setSettings] = React.useContext(SettingsContext);
  let settingsState = useSettingsContext();
  let history = useHistory();
  let compState = settings.competitionStatus.openState;
  let compPhaseId = settings.competitionStatus.currentPhasePublicId;
  let competitionIsOpen = compState === "Open";
  let competitionIsNotStarted = compState === "NotStarted";
  let competitionIsMopUp = compPhaseId === "mop-up";
  let competitionIsClosed = compState === "Closed";
  const [showEntryModal, setShowEntryModal] = useState(false);
  const [showCountryModal, setShowCountryModal] = useState(!settings.country);
  const [showCountryCtaModal, setShowCountryCtaModal] = useState(false);
  let [validation, setValidation] = useState({
    errors: new ValidationErrorCollection(),
    acknowledged: false
  });

  let currency = (settings.country === "ROI" ? "€" : (settings.country === "GB" || settings.country === "NI") ? "£" : "£/€");
  let voucher = (settings.country === "ROI" ? "AllGifts.IE" : "Lifestyle");




  useEffectOnce(() => {
    var isDesk = window.matchMedia("only screen and (min-width: 1200px)").matches;
    var conffetiNodes = 80;
    if (isDesk && (!competitionIsNotStarted && competitionIsOpen)) {
      conffetiNodes = 200;
    }

    async function confetti() {
      Stage.init({
        nodeCount: conffetiNodes,
        typeGold: true
      });
    }

    if(competitionIsOpen && !competitionIsMopUp){
      timer.delay(500).then(() => confetti());
    }

    //timer.delay(5000).then(() => Stage.destroy());

    return () => Stage.destroy();

  });


  const handleCountrySelected = (data) => {
    sessionStorage && sessionStorage.setItem('cadburyfc.country', data.country);
    settingsState.setCountry(data.country);
    setShowCountryModal(false);
  }

  const handleEnterNow = async (e, comp) => {
    if (settings.country === "GB" || settings.country === "NI") {
      analyticsService.logEvent("button_click", "site_modal", {
        location: comp,
        label: "proof of purchase modal",
        url: ""
      });

      setShowEntryModal(true);
    } else {
      var roiUrl = "/prize-select";
      var roiLabel = "prize selection page";

      if(competitionIsMopUp){
        roiUrl = "/registration";
        roiLabel = "entry registration page";
      }

      analyticsService.logEvent("button_click", "internal_link", {
        location: comp,
        label: roiLabel,
        url: roiUrl
      });      
      history.push(roiUrl);
    }
  }

  const renderSteps = (steps) => {
    return steps.map((step, index) => {
      return (
        <Step key={step.number} {...step} />
      )
    })
  }


  const renderEntryCta = (title, component) => {
    if (!settings.country) return null;

    return <Button
      wide
      type="submit"
      title={title ? title : "Enter Now"}
      onClick={e => handleEnterNow(e, component)}
    />
  }

  const renderIntroMessage = (compState) => {
    switch (compState) {
      case 'Open':
        return <>
        {
          !competitionIsMopUp ? (
            <div className="home__intro">
              <div className="home__intro__content">
                <h2 className='type-h1 type-h1--xl type-h1--gold'>Incredible prizes to be won</h2>
                <picture>
                  <img className="players-mob" src={players_mob} srcSet={players_mob_2x + " 2x, " + players_mob + " 1x"} alt="players" />
                </picture>
              </div>
              
              <div className="home__intro__content bg-texture">
                <h2 className='type-h1'>Meet <br></br>Players</h2>
                <h2 className='type-h2 type-h2--thin type-h2--gold'>who inspire</h2>
                
                <div className="home__intro-body home__intro-body--thin">
                  <p>
                  Win an experience with one of the women changing the game of football: <span><strong>Jill Scott, Leah Williamson, Katie McCabe or Lauren James!</strong></span> Plus a hotel stay, travel, signed shirt and a Cadbury hamper – all to share with three of your game changing friends or family.
                  </p>
                </div>
                <div className="home__cta">
                  {renderEntryCta("Enter now", "home_entry")}
                </div>
              </div>
            </div>
          ) : (
            <div className="home__intro home__intro--slim">
              <h2 className='type-h2'>Game changing wins has now finished, but don't worry!</h2>
              <div class="goldbar"></div>
              <div className="home__intro-body">

              {settings.country === "ROI" ? (
                <p className="large">We’ve got an <strong className="gold">EPIC prize draw</strong> with the chance to win a <strong className="gold">{currency}250 AllGifts.IE gift cards.</strong></p> 
              ) : (
                <p className="large">We’ve got an <strong className="gold">EPIC prize draw</strong> with the chance to win a <strong className="gold">{currency}250 Lifestyle voucher.</strong></p>
              )}

              <div className="home__cta">
              {renderEntryCta("Enter now", "home_entry")}
              </div>

              </div>
            </div>
          )
        }
          
        </>

      case 'NotStarted':
        return <>
          <div className="home__intro home__intro--wide">
            <h2 className='type-h3 text-transform-off type-h3--gold'>Want to meet inspiring game changing players?</h2>
            <div className='home__intro-body'>
              <p> This is your chance! Plus you could score motivating match tickets and vouchers <span class="uppercase">every single day.</span></p>
              <p>It's all to play for!</p>
              <p><strong>Game Changing Wins, coming 28th April 2025.</strong></p>
              <p>Sign up to be reminded when we kick off.</p>
            </div>
          </div>

          <div className="home__cta">
            <Button
                wide
                type="submit"
                title="Sign Up"
                onClick={() => setShowCountryCtaModal(true)}
              />
          </div>          
        </>

      case 'Closed':
        return <>
          <div className="home__intro">

            <h2 className='type-h2'>The game's over</h2>
            <div class="goldbar"></div>
            <div className="home__intro-body">
              <p>
              The final whistle has blown on Game Changing Wins. For more chances to win match tickets and other inspiring football prizes, sign up for a Cadbury FC account and select to receive emails so that we can keep you posted on all our future promotions.
              </p>
              <div className="home__cta home__cta--bottom-space">
              <Button
                wide
                type="submit"
                title="Sign Up"
                onClick={() => setShowCountryCtaModal(true)}
                />
            </div>
            </div>

          </div>

        </>
    }
  }

  return (
    <div className="layout">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Home | Cadbury FC - Game Changing Wins</title>
      </Helmet>
      {competitionIsOpen &&
        <>
          <CodeEntry
            show={showEntryModal}
            onDismiss={() => setShowEntryModal(false)}
            onEntry={() => history.push(!competitionIsMopUp ? "/prize-select":"/registration") } 
          />

          <CountrySelect
            show={showCountryModal}
            onCountrySelected={handleCountrySelected}
          />
        </>
      }

      {
        !competitionIsOpen && 
          <CountryCtaModal
            show={showCountryCtaModal}
            onDismiss={() => setShowCountryCtaModal(false)}
            competitionIsClosed={competitionIsClosed}
          /> 
      }

      <h1 className="visually-hidden">Cadbury FC - Game Changing Wins</h1>

      <section className="layout-wrapper home__banner">
        <div className="home__banner-container">
          <div className="home__banner-content">
            <HomeHero 
            video={competitionIsOpen && !competitionIsMopUp}
            poster={placeholder_image}
            />
          </div>
        </div>
      </section>

    
      <section className={"layout-wrapper home__entrybar relative " + (competitionIsOpen && !competitionIsMopUp ? "bg-texture" : "")}>
        <div className={"layout-container layout-container--center " + (competitionIsOpen && !competitionIsMopUp ? "layout-container--full home__entrybar__images" : "")}>

          {renderIntroMessage(compState)}
          
        </div>
      </section>

        
        {(competitionIsOpen && !competitionIsMopUp) &&
          <div id="confetti-container" className="relative home__confetti-section bg-texture-gradient">
            <section className="layout-wrapper home__prize-block-section">
              <div className="layout-container layout-container--center">
                <h2 className="type-h1 type-h1--gold type-h1--xl">Plus daily chances to win...</h2>
                <div className="home__prize-blocks">
                  <PrizeBlock
                    imageMob={MatchTicketsMob}
                    imageMobLarge={MatchTicketsMob2x}
                    image={MatchTicketsDesk}
                    imageLarge={MatchTicketsDesk2x}
                    title="Match <br>Tickets"
                    subTitle="That Motivate"
                    description={`<p>Hundreds of pairs of tickets to catch players in action.</p>`}
                    alt="Signed shirt and video player graphic"
                  />
                  {(settings.country === "ROI") ? (
                      <PrizeBlock
                      imageMob={VouchersMobRoi}
                      imageMobLarge={VouchersMobRoi2x}
                      image={VouchersDeskRoi}
                      imageLarge={VouchersDeskRoi2x}
                      title="100<span class='lowercase'>s</span> of <br>vouchers"     
                      subTitle="To kick-start <br>your passion"             
                      description={`<p>€50 or €100 to spend on whatever you need to up your game.</p>`}
                      alt="10 and 5 euros vouchers"
                      />      
                     ) : (
                      <PrizeBlock
                      imageMob={VouchersMob}
                      imageMobLarge={VouchersMob2x}
                      image={VouchersDesk}
                      imageLarge={VouchersDesk2x}
                      title="100<span class='lowercase'>s</span> of <br>vouchers"     
                      subTitle="To kick-start <br>your passion"             
                      description={`<p>£50 or £100 to spend on raising your game.</p>`}
                      alt="10 and 5 pound vouchers"
                    /> 
                    )}
                </div>

              </div>
            </section>
            
          </div>
        }


      {
        (competitionIsOpen) &&
        <section className={"layout-wrapper " + (competitionIsMopUp ? "bg-dark" : "")} id="how-to-play">
          <div className={"layout-container layout-container--center " + (!competitionIsMopUp ? "layout-container--wide" : "")}>
            <h2 id="howitworks" className="type-h1">How do i enter?</h2>
            <div className={"home__steps " + (settings.country === "ROI" ? "home__steps--roi" : "home__steps--gb")}>
            {
                (!competitionIsMopUp) ? (

                  
                    (settings.country === "ROI") ?
                      (

                        <>
                        <Carousel 
                        className="home__steps__carousel"
                        params={{
                          watchOverflow: true,
                          spaceBetween: 30,
                          slidesPerView: 1,
                          centeredSlides: false,
                          pagination: {
                            el: '.swiper-pagination',
                            clickable: true
                          },
                          navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                          },
                          runCallbacksOnInit: true,
                          slidesPerGroup: 1,
        
                          breakpoints: {
                            768: {
                              slidesPerView: 2,
                              spaceBetween: 0,
                              slidesPerGroup: 1,
                            },
                            992: {
                              slidesPerView: 4,
                              spaceBetween: 0,
                              slidesPerGroup: 4,
                            }
                          }
                        }}
                        >

                          {     
                          renderSteps([
                            { number: 1, title: " Select your game-changing player", image: How4, image2x: How4_2x, alt: "Jill Scott, Leah Williamson, Katie McCabe, Lauren James." },
                            { number: 2, title: "Enter your personal details", image: How1, image2x: How1_2x, alt: "Form Graphic." },
                            { number: 3, title: "Find out instantly if you've won match tickets or a voucher. ", image: How6, image2x: How6_2x, alt: "Game Changing Wins.", description: "The prize draw for the game changer meet and greet will take place after 28/07/25" },
                          ])
                          }
                          </Carousel>
                          <div className='home__steps__nav home__steps__nav--gold'>
                            <div className='swiper-pagination'></div>
                          </div>
                        </>

                      ) : (

                        <>
                        <Carousel 
                        className="home__steps__carousel test"
                        params={{
                          watchOverflow: true,
                          spaceBetween: 30,
                          slidesPerView: 1,
                          centeredSlides: false,
                          pagination: {
                            el: '.swiper-pagination',
                            clickable: true
                          },
                          navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                          },
                          runCallbacksOnInit: true,
                          slidesPerGroup: 1,
        
                          breakpoints: {
                            768: {
                              slidesPerView: 2,
                              spaceBetween: 0,
                              slidesPerGroup: 1,
                            },
                            992: {
                              slidesPerView: 3,
                              spaceBetween: 0,
                              slidesPerGroup: 3,
                            }
                          }
                        }}
                        >

                          {     
                          renderSteps([
                          { number: 1, title: "Buy a Participating Product", image: How5, image2x: How5_2x, alt: "Cadbury products", descriptionLink: <><a href="/terms-and-conditions#products-list" rel="noopener noreferrer" target='_blank'>See full product list here</a></> },
                          { number: 2, title: "Enter the barcode and batch code of your product", image: How2, image2x: How2_2x, alt: "A barcode and batch code from a Cadbury pack" },
                          { number: 3, title: "Enter your details and select your game changing player", image: How4, image2x: How4_2x, alt: "Jill Scott, Leah Williamson, Katie McCabe, Lauren James." },
                          { number: 4, title: "Find out instantly if you've won match tickets or a voucher.", image: How6, image2x: How6_2x, alt: "Game Changing Wins.", description: "The prize draw for the game changer meet and greet will take place after 28/07/25" }
                          ])
                          }
                          </Carousel>
                          <div className='home__steps__nav home__steps__nav--gold'>
                            <div className='swiper-pagination'></div>
                          </div>
                        </>
                      )

                      ) : (
                    
                      (settings.country === "ROI") ?
                        (
                          renderSteps([
                            { number: 1, title: "Enter your personal details", image: How1, image2x: How1_2x, alt: "Form Graphic." },
                            { number: 2, title: "Follow the instructions to enter our final prize draw!", image: How3, image2x: How3_2x, alt: "€250"},
                          ])
      
                        ) : (
                          <>
                            <Carousel 
                            className="home__steps__carousel"
                            params={{
                              watchOverflow: true,
                              spaceBetween: 30,
                              slidesPerView: 1,
                              centeredSlides: false,
                              pagination: {
                                el: '.swiper-pagination',
                                clickable: true
                              },
                              navigation: {
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev',
                              },
                              runCallbacksOnInit: true,
                              slidesPerGroup: 1,
            
                              breakpoints: {
                                768: {
                                  slidesPerView: 2,
                                  spaceBetween: 0,
                                  slidesPerGroup: 1,
                                },
                                992: {
                                  slidesPerView: 3,
                                  spaceBetween: 0,
                                  slidesPerGroup: 3,
                                }
                              }
                            }}
                            >

                              { renderSteps([
                                { number: 1, title: "Buy a participating product", image: How5, image2x: How5_2x, alt: "Cadbury products", descriptionLink: <><a href="/terms-and-conditions#products-list" rel="noopener noreferrer" target='_blank'>See full product list here</a></> },
                                { number: 2, title: "Enter the barcode and batch code of your product", image: How2, image2x: How2_2x, alt: "A barcode and batch code from a Cadbury pack" },
                                { number: 3, title: "Follow the instructions to enter our final prize draw!", image: How3b, image2x: How3b_2x, alt: "£250 e-voucher." },
                              ])
                            }
                        </Carousel>
                        <div className='home__steps__nav home__steps__nav--gold'>
                          <div className='swiper-pagination'></div>
                        </div>
                      </>
                  )     
                )
            }
            
            </div>
            <div className="home__cta">
              {renderEntryCta("Enter Now", "home_howto_steps")}
            </div>
          </div>
        </section>
      }

      {
        (competitionIsOpen && !competitionIsMopUp) &&
        <section className="layout-wrapper bg-secondary">
          <div className="home__video">
            <div className="home__video__intro bg-texture bg-texture--desk">
              <h2 className="type-h1 type-h1--gold type-h1--xl">A little support</h2>
              <h2 className="type-h1">can change the game</h2>
              <p>Our game changing players wouldn't be where they are today without the kindness of their friends and family. Learn more about their inspirational stories here.</p>  
            </div>
          <Video 
          deskSrc={gcw_video}
          src={gcw_video_mob}
          poster={placeholder_image}
          / >
          </div>
        </section>

      }


      <SummaryTsandCs 
        reduced={competitionIsNotStarted} 
        className={competitionIsNotStarted ? "bg-gradient " : competitionIsMopUp ? "bg-dark" : competitionIsOpen ? "bg-very-dark" : ""}
      />
      
    </div >
  );
}